exports.default = {
  'create_agent': 'New Agent',
  'edit_agent': 'Edit Agent',
  'submit_failed': 'Unable to save. Your input is preserved. Please try again.',
  'avatar_upload_failed': 'Unable to upload the avatar. Please try again.',
  'agent_name': 'Agent Name',
  'agent_name_placeholder': 'Enter agent name',
  'agent_function_intro': 'Agent Description',
  'agent_function_intro_placeholder': 'Describe what this agent can do',
  'avatar': 'Avatar',
  'get_started': 'Get Started',
  'input_brief': 'Please enter agent brief and usage guide',
  'edit_avatar': 'Change Avatar',
  'greetings': 'Hello!',
  'greetings_promtp': 'Greeting',
  'greetings_promtp_placeholder': 'Please enter agent brief and usage guide',
  'ai_model': 'AI Model',
  'select': 'Please select',
  'brief': 'Brief',
  'leading_questions': 'Guiding questions after answering',
  'citing_sources': 'Cite Sources',
  'citing_sources_desc': 'When enabled, AI will display document sources referenced in answers',
  'markdown_desc': 'When enabled, content supports Markdown format display',
  'data_source': 'Data Source',
  'set_model_context': 'Set Model Context',
  'set_model_context_desc': 'When enabled, AI will have permission to access specified project content as reference for answering questions',
  'confirm': 'Confirm',
  'confirm_upload': 'Confirm Upload',
  'input_prompt': 'Please enter model prompt, which can be used to set model identity and instruction requirements',
  'return': 'Return',
  'opening_greetings': 'Opening Greeting',
  'auto_generate': 'Auto Generate',
  'crop_image': 'Crop Image',
  'model_parameters': 'Model Parameters',
  'opening_greetings_placeholder': 'Send this message at the beginning of each conversation, allowing the agent to proactively speak first can bring users closer',
  'next_question_advise': 'Next Question Suggestion',
  'next_question_advise_desc': 'Provide 3 input suggestions for users after AI replies',
  'preview_and_debug': 'Preview and Debug',
  'suggestion': 'Suggestion',
  'suggestion_desc': 'We recommend using structured prompts to create agent roles and pre-prompts. Structured prompts are easier to read, can improve answer efficiency, and provide a better answer experience.',
  'copy': 'Copy',
  'prompt_optimize': 'Prompt Optimization',
  'balance': 'Balance',
  'originality': 'Originality',
  'accurate': 'Accurate',
  'custom': 'Custom',
  'chat_enhancement': 'Chat Enhancement',
  'please_input_name': 'Please enter name',
  'please_input_brief': 'Please enter brief',
  'please_input_prompt': 'Please enter model prompt, which can be used to set model identity and instruction requirements',
  'retry': 'Retry',
  'use': 'Use',
  'greetings_optimize': 'Greeting Optimization',
  'unpublished_prompt': 'This creation has not been saved, are you sure you want to leave?',
  'prompt': 'Prompt',
  'need_crop_image': 'Do you need to crop the image?',
  'crop': 'Crop',
  'release': 'Release',
  'confirm_leave': 'Confirm Leave',
  'upload_without_crop': 'Upload without cropping',
  'upload_image': 'Upload Image',
  'name_required': 'Agent name required',
  'avatar_required': 'Please upload avatar',
  'intro_required': 'Description required',
  'save_success': 'Save successful',
  'image_type_error': 'Image type must be one of: gif, jpeg, jpg, png, bmp',
  'form_not_complete': 'Form is incomplete, please check and resubmit!',
  'under_development': 'Under development...',
  'agent_settings': 'Agent Settings',
  'integration': 'Integration',
  'data_analysis': 'Data Analysis',
  'user_feedback': 'User Feedback',
  'member_settings': 'Member Settings',
  'agent_creation': 'Agent Creation',
  'choose_template': 'Choose Template',
  'empty_template': 'Empty Template',
  'empty_template_desc': 'Create your agent from scratch',
  'choose_model': 'Choose Model',
  'basic_info': 'Basic Info',
  'agent_desc': 'Agent Description',
  'agent_desc_placeholder': 'Please enter agent description',
  'agent_avatar': 'Agent Avatar',
  'upload_avatar': 'Upload Avatar',
  'go_chat': 'Go Chat',
  'continue_modify': 'Continue Modifying',
  'release_success': 'Release successful!',
  'setting': 'Setting',
  'randomness': 'Randomness',
  'randomness_tip': 'Adjust the creativity and diversity of AI responses, higher values result in more diverse answers',
  'configure_agent': 'Configure Agent',
  'stable': 'Stable',
  'neutral': 'Neutral',
  'prompt_tips': 'Prompt Tips',
  'random': 'Random',
  'view_reference_example': 'View Reference Example',
  'optimize': 'Quick Optimize',
  'prompt_placeholder': 'Please enter agent prompt, e.g.: You are a professional Java developer skilled in Spring Boot development...',
  'save_failed': 'Save failed, missing required configuration information, please check!',
  'new_conversation': 'New Conversation',
  'debug_mode_not_share': 'Debug mode does not allow sharing',
  'agent_prompt': 'Agent Prompt',
  'agent_prompt_tip': 'Here you can describe your agent in detail, such as what role it should play, what it\'s good at, how it should answer questions, etc. All conversations will be based on this prompt.',
  'agent_prompt_placeholder': 'Please enter agent prompt, e.g.: You are a professional Java developer skilled in Spring Boot development...',
  'first_question': 'First Question',
  'first_question_tip': 'When users first talk to your agent, the agent will proactively ask this question',
  'first_question_placeholder': 'Please enter first question, e.g.: Hello, I\'m an AI assistant, how can I help you?',
  'knowledge_base': 'Knowledge Base',
  'select_knowledge_base': 'Select Knowledge Base',
  'knowledge_base_tip': 'After selecting a knowledge base, the agent will search for relevant information in the knowledge base when users ask questions, and use this information to answer questions',
  'no_knowledge_base': 'No knowledge base',
  'create_knowledge_base': 'Create Knowledge Base',
  'access_permission': 'Access Permission',
  'team_public': 'Team Public',
  'team_public_desc': 'All team members can use it',
  'team_private': 'Team Private',
  'team_private_desc': 'Only you and specified members can use it',
  'web_public': 'Web Public',
  'web_public_desc': 'Can generate web links, anyone can access',
  'all_members_tip': 'All members ({count})',
  'member_count': '{count} members',
  'cancel': 'Cancel',
  'save': 'Save',
  'create': 'Create',
  'choose_avatar': 'Choose Avatar',
  'agent_avatar_tip': 'Choose an avatar for your agent, it will be displayed in the conversation interface',
  'use_default_avatar': 'Use Default Avatar',
  'upload_local_image': 'Upload Local Image',
  'upload_tip': 'Support .jpg .jpeg .png .gif formats, size not exceeding 3MB',
  'model_recommend': 'Recommended',
  'model_desc': 'Model Description',
  'completion_model': 'Completion Model',
  'completion_model_desc': 'Suitable for text generation, content creation, conversation generation, etc.',
  'embedding_model': 'Embedding Model',
  'embedding_model_desc': 'Suitable for semantic search, text similarity calculation, etc.',
  'model_provider': 'Model Provider',
  'model_parameter': '{parameter} parameters',
  'model_training': 'Trained on {training_date}',
  'knowledge_base_selected': 'Knowledge base selected: {name}',
  'agent_name_required': 'Please enter agent name',
  'agent_prompt_required': 'Please enter agent prompt',
  'agent_first_question_required': 'Please enter first question',
  'create_success': 'Creation successful',
  'leave_confirm': 'Are you sure you want to leave this page? Your changes may not be saved.',
  'leave_page': 'Leave Page',
  'stay_on_page': 'Stay on Page',
  'edit_members': 'Edit Members',
  'member_list': 'Member List',
  'member_count_tip': '{count} members selected',
  'search_member': 'Search Member',
  'all_members': 'All Members',
  'selected_members': 'Selected Members',
  'agent_link': 'Agent Link',
  'link_tip': 'With the following link, you can share and use your agent anywhere, anyone can access and use it',
  'page_link': 'Page Link',
  'scan_qrcode': 'Scan QR Code',
  'embed_code': 'Embed Code',
  'embed_tip': 'Embed this code into your website to use your agent on your site',
  'embed_code_copied': 'Embed code copied',
  'link_copied': 'Link copied',
  'close': 'Close',
  'member_management': 'Member Management',
  'member_search_placeholder': 'Search member name',
  'add_member': 'Add Member',
  'name': 'Name',
  'permission': 'Permission',
  'operation': 'Operation',
  'remove': 'Remove',
  'add_new_member': 'Add New Member',
  'search_by_name': 'Search by member name',
  'no_results': 'No search results',
  'admin': 'Admin',
  'editor': 'Editor',
  'viewer': 'Viewer',
  'team_owner': 'Team Owner',
  'team_admin': 'Team Admin',
  'agent_owner': 'Agent Owner',
  'remove_confirm': 'Are you sure you want to remove this member?',
  'remove_success': 'Member removed successfully',
  'add_success': 'Member added successfully',
  'permission_update_success': 'Permission updated successfully',
  'agent_setting': 'Agent Setting',
  'model_setting': 'Model Setting',
  'reset_setting': 'Reset Setting',
  'setting_reset_confirm': 'Are you sure you want to reset all settings?',
  'settings_reset_success': 'Settings have been reset',
  'delete_agent': 'Delete Agent',
  'delete_agent_confirm': 'Are you sure you want to delete this agent? This action cannot be undone.',
  'delete_success': 'Delete successful',
  'agent_deleted': 'The agent has been deleted',
  'agent_disabled': 'The agent has been taken off the shelf',
  'get_link': 'Get Link',
  'advanced_settings': 'Advanced Settings',
  'context_window': 'Context Window',
  'context_window_tip': 'Set the number of messages the agent can "remember". A larger value allows the agent to remember more historical messages, but also increases API call costs.',
  'message_count': '{count} messages',
  'temperature': 'Temperature',
  'temperature_tip': 'Controls the randomness of the output. Lower values make the output more deterministic, higher values make the output more diverse and creative.',
  'top_p': 'Top P',
  'top_p_tip': 'Controls the probability mass of vocabulary the model considers when generating each token. Lower values make the output more deterministic, higher values make the output more diverse.',
  'max_tokens': 'Max Tokens Per Reply',
  'max_tokens_tip': 'Controls the maximum number of tokens the model generates in each reply. Larger values allow the model to generate longer replies.',
  'tokens_count': '{count} tokens',
  'presence_penalty': 'Presence Penalty',
  'presence_penalty_tip': 'Controls the model\'s tendency to repeat already-present tokens. Higher positive values penalize the model for repeating tokens that have already appeared.',
  'frequency_penalty': 'Frequency Penalty',
  'frequency_penalty_tip': 'Controls the model\'s tendency to repeat frequently appearing tokens. Higher positive values penalize the model for repeating frequently appearing tokens.',
  'points_per_request': '{points} points/request'
}
